import L from "leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import { useTrackingStore } from "../store";
import type { ClusteredVehiclesProps } from "../types";
import { VehicleMarker } from "./vehicle-marker";

export const ClusteredVehicles = ({
	telemetries,
	onVehicleSelect,
}: ClusteredVehiclesProps) => {
	const { vehicleFilterId } = useTrackingStore();

	const telemetriesWithCoordinates = telemetries.filter(
		(telemetry) =>
			telemetry.latitude &&
			telemetry.longitude &&
			(vehicleFilterId === null || telemetry.vehicleId === vehicleFilterId)
	);

	const vehicleMarkers = telemetriesWithCoordinates.map((telemetry) => (
		<VehicleMarker
			key={telemetry.vehicleId}
			onVehicleSelect={onVehicleSelect}
			telemetry={telemetry}
		/>
	));

	const createClusterIcon = (cluster: { getChildCount: () => number }) => {
		const vehicleCount = cluster.getChildCount();
		const clusterSize = 40;

		let backgroundColor = "#0080FE";
		if (vehicleCount > 10) {
			backgroundColor = "#175CD3";
		}

		return L.divIcon({
			html: `<div style="background-color: ${backgroundColor}; color: white; border-radius: 50%; width: ${clusterSize}px; height: ${clusterSize}px; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: ${Math.max(12, clusterSize / 4)}px;">${vehicleCount}</div>`,
			className: "custom-cluster-icon",
			iconSize: [clusterSize, clusterSize],
		});
	};

	return (
		<MarkerClusterGroup
			chunkedLoading
			iconCreateFunction={createClusterIcon}
			maxClusterRadius={60}
			showCoverageOnHover
			spiderfyOnMaxZoom
			zoomToBoundsOnClick
		>
			{vehicleMarkers}
		</MarkerClusterGroup>
	);
};
